// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2tPa9","description":"PatientConsentPreview_description__1taha"};